/**
 * Contact us form flags
 */

export const abandonCartFlags = {
  abandonCartEnable: process.env.ABANDON_CART_ENABLE === 'true',
};
